// extracted by mini-css-extract-plugin
module.exports = {"container":"Checkbox-module--container--bee173","checkbox":"Checkbox-module--checkbox--83e4f2","label":"Checkbox-module--label--c47530","shake":"Checkbox-module--shake--1af8a2"};